import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, ChapterLabel } from "@/components/Reveal";
import { useLang } from "@/i18n";
import { IMAGES } from "@/content/images";

const Place = () => {
  const ref = useRef(null);
  const { t } = useLang();
  const d = t.place;
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section data-testid="place-section" className="bg-ivory">
      <div className="px-6 md:px-12 pt-28 md:pt-44 pb-16 md:pb-24 mx-auto max-w-[1600px]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <ChapterLabel index={d.chapter} title={d.label} />
            <Reveal delay={0.1}>
              <h2 data-testid="place-headline"
                className="mt-10 font-display text-charcoal text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
                {d.headingA} <span className="italic font-light">{d.headingB}</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="md:col-span-4 md:col-start-9">
            <p className="text-base leading-relaxed text-charcoal/65">{d.copy}</p>
          </Reveal>
        </div>
      </div>

      <div ref={ref} className="relative h-[62vh] md:h-[82vh] overflow-hidden">
        <motion.img src={IMAGES.place} alt="Baja California desert meeting the sea near Cabo San Lucas"
          data-testid="place-image" loading="lazy" style={{ y: imgY }}
          className="h-full w-full scale-110 object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/35 to-transparent" />
        <div className="absolute bottom-8 left-6 md:left-12">
          <p className="label-caps text-ivory/80">{d.caption}</p>
        </div>
      </div>
    </section>
  );
};

export default Place;
